import { ShieldCheck, Trophy, Clock4, HardHat } from "lucide-react";

const TRUST_ITEMS = [
    {
        id: "experience",
        value: "20+",
        unit: "Years",
        label: "Of Lifting Experience",
        Icon: Trophy,
    },
    {
        id: "projects",
        value: "1000+",
        unit: "Projects",
        label: "Completed Across Maharashtra",
        Icon: HardHat,
    },
    {
        id: "availability",
        value: "24/7",
        unit: "On-Call",
        label: "Round-the-clock Dispatch",
        Icon: Clock4,
    },
    {
        id: "safety",
        value: "0",
        unit: "Compromise",
        label: "On Safety & Compliance",
        Icon: ShieldCheck,
    },
];

export const Trust = () => {
    return (
        <section
            data-testid="trust-section"
            className="relative bg-[#0A0A0A] border-y border-white/10"
        >
            {/* Marquee */}
            <div className="overflow-hidden border-b border-white/10 bg-[#FFC107] py-3">
                <div className="flex marquee-track gap-12 whitespace-nowrap">
                    {Array.from({ length: 2 }).map((_, dup) => (
                        <div
                            key={dup}
                            className="flex items-center gap-12 shrink-0"
                        >
                            {[
                                "Mumbai",
                                "Thane",
                                "Bhiwandi",
                                "Navi Mumbai",
                                "12T → 100+T",
                                "Industrial Logistics",
                                "On-Site Operations",
                                "ISO Safety Standards",
                            ].map((t, i) => (
                                <span
                                    key={`${dup}-${i}`}
                                    className="font-display text-2xl md:text-3xl uppercase text-black tracking-wider flex items-center gap-12"
                                >
                                    {t}
                                    <span className="inline-block w-2 h-2 bg-black rotate-45" />
                                </span>
                            ))}
                        </div>
                    ))}
                </div>
            </div>

            <div className="max-w-7xl mx-auto px-5 lg:px-8 py-16 lg:py-20">
                <div className="grid grid-cols-2 lg:grid-cols-4 gap-px bg-white/10">
                    {TRUST_ITEMS.map(
                        ({ id, value, unit, label, Icon }, idx) => (
                            <div
                                key={id}
                                data-testid={`trust-card-${id}`}
                                className="reveal group bg-[#0A0A0A] hover:bg-[#171717] transition-colors duration-300 p-6 md:p-10 flex flex-col gap-4"
                                style={{ animationDelay: `${idx * 0.08}s` }}
                            >
                                <div className="flex items-center justify-between">
                                    <Icon
                                        size={28}
                                        strokeWidth={1.6}
                                        className="text-[#FFC107]"
                                    />
                                    <span className="font-display text-sm text-neutral-700">
                                        0{idx + 1}
                                    </span>
                                </div>
                                <div className="flex items-baseline gap-2 flex-wrap">
                                    <span className="font-display text-5xl md:text-6xl lg:text-7xl text-white leading-none">
                                        {value}
                                    </span>
                                    <span className="font-body text-xs md:text-sm uppercase tracking-[0.2em] text-[#FFC107]">
                                        {unit}
                                    </span>
                                </div>
                                <p className="font-body text-sm text-neutral-400 leading-relaxed">
                                    {label}
                                </p>
                            </div>
                        ),
                    )}
                </div>
            </div>
        </section>
    );
};
